// extracted by mini-css-extract-plugin
export default {"root":"JobCard_root__ughrM"};